export default {
  // GeneralFormat
  CurrencyGroupSeparator: '.', // NumberGroupSeparator
  CurrencyDecimalSeparator: ',', // NumberDecimalSeparator
  CurrencyDecimalDigits: 0, // Số chữ số sau dấu phẩy - Số tiền
  NumberDecimalDigits: 1, // Số chữ số sau dấu phẩy - Số lượng
  PercentDecimalDigits: 2,
  CurrencySymbol: 0,
  CurrencyNegativeForeColor: '#FF0000',
  NumberNegativePattern: 0,
  // ReadAmount
  SayMoney_Prefix: '',
  SayMoney_Surfix: '',
  SayMoney_IsCustomize: false,
  SayMoney_Nghin: 'nghìn',
  SayMoney_Linh: 'linh',
  SayMoney_Muoi: 'mươi',
  SayMoney_4: 'tư',
  SayMoney_7: 'bảy',
  ReadTheAmount: '99345678987654',
  SayMoney_Even: true,
};
